import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  isAbleToSeeUIElement,
  UserViewRoles,
} from '../../utils/roles/client-roles';
import { Messages } from '../../utils/message-constants';
import { UserKeys } from '../../api/users-api';
import { useUserSettings } from '../../utils/use-user-settings';
import SharedToolbar from '../../shared/shared-toolbar-latest';
import CreateButton from '../../shared/buttons/create-button';
import SharedIconButton from '../../shared/buttons/shared-icon-button';
interface AllGroupsGridToolbarProps {
  paginationModel: {
    pageSize: number;
    page: number;
    cursor: string | null;
    search: string;
  };
  setPaginationModel: Dispatch<
    SetStateAction<{
      pageSize: number;
      page: number;
      cursor: string | null;
      search: string;
    }>
  >;
  setOpenAddGroup: Dispatch<SetStateAction<boolean>>;
}

export default function AllGroupsGridToolbar({
  paginationModel,
  setPaginationModel,
  setOpenAddGroup,
}: AllGroupsGridToolbarProps) {
  const queryClient = useQueryClient();
  const { userViewRoles } = useUserSettings();

  return (
    <SharedToolbar
      noFilter
      quickFilterDebounceMs={300}
      primaryButtons={
        <CreateButton
          variant="contained"
          disabled={
            !isAbleToSeeUIElement(
              userViewRoles,
              UserViewRoles.CreateGroup.value
            )
          }
          onClick={() => setOpenAddGroup(true)}
          label="Add Group"
          tooltipLabel={
            !isAbleToSeeUIElement(
              userViewRoles,
              UserViewRoles.CreateGroup.value
            )
              ? Messages.Errors.Permission.Acting(
                  UserViewRoles.CreateGroup.name
                )
              : ''
          }
        />
      }
      secondaryButtons={
        <SharedIconButton
          variant="refresh"
          onClick={() => {
            setPaginationModel({
              page: 0,
              pageSize: paginationModel.pageSize,
              cursor: null,
              search: '',
            });
            [
              UserKeys.Groups,
              UserKeys.DirectoryGroup,
              UserKeys.GroupSettings,
              UserKeys.GroupLabels,
            ].forEach((key) => {
              void queryClient.invalidateQueries({ queryKey: [key] });
            });
          }}
          tooltipLabel="Refresh"
        />
      }
    />
  );
}
